// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg[data-v-1478d499]{position:fixed;top:0;right:-135px;width:477px}@media (min-width: 960px){.bg[data-v-1478d499]{right:-110px;width:736px}}.bg[data-v-1478d499]{z-index:-1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
